import { useLayoutEffect, useState } from 'react';

export const useIsSmartphoneDevice = (ref?: React.RefObject<HTMLElement>) => {
  const checkForDevice = () => (ref?.current && ref?.current?.clientWidth < 768) || window.innerWidth < 768;

  const [isMobile, setIsMobile] = useState(checkForDevice());

  useLayoutEffect(() => {
    if (ref) {
      setIsMobile(checkForDevice());
    }

    const handlePageResized = () => {
      setIsMobile(checkForDevice());
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handlePageResized);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', handlePageResized);
      }
    };
  }, [isMobile]);

  return {
    isMobile,
  };
};
